import "./Issuers.scss";
import {
  IonAvatar,
  IonCard,
  IonCardContent,
  IonContent,
  IonFab,
  IonFabButton,
  IonFabList,
  IonIcon,
  IonLoading,
  IonPage,
  IonText,
  IonToast,
  IonImg,
  IonSegment,
  IonSegmentButton,
  IonList,
  IonItem,
  IonLabel,
  useIonViewWillEnter,
} from "@ionic/react";
import { add, starOutline, cameraOutline, menuOutline } from "ionicons/icons";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import Carousel from "react-elastic-carousel";
import { smartColors } from "../../utils/helpers/Colors";
import ViewIssuer from "../../components/ViewIssuer";
import { v4 } from "uuid";
// import _findIndex from "lodash/fp/findIndex";
import {
  BarcodeScanner,
  BarcodeScannerOptions,
} from "@ionic-native/barcode-scanner";
import { authLogin } from "../../context/auth";
import { useTracked } from "../../state";
import CameraPermissionDialog from "../../components/CameraPermissionDialog";
import { getIssuers, setIssuer, updateIssuer } from "../../api/issuer";
import illustrations from "../../assets/svg/Illustrations.svg";
import qrCodeIcon from "../../assets/svg/qrcode.svg";
import carouselHorizontal from "../../assets/svg/carbon_carousel-horizontal.svg";
import cardAvatar from "../../assets/images/avatar-card.png";
import {
  getRequestHistoryByIdentity,
  createRequestHistory,
} from "../../api/requestHistory";
import moment from "moment";
import PrivateHeader from "../../components/PrivateHeader";
import { ShowToastSuccessMessage } from "../../utils/helpers/ToastMessage";

const options: BarcodeScannerOptions = {
  disableAnimations: true,
  preferFrontCamera: false,
  showFlipCameraButton: false,
  showTorchButton: true,
  torchOn: false,
  prompt: "Place qr code inside the scan area",
  resultDisplayDuration: 500,
  formats: "QR_CODE,PDF_417",
  orientation: "portrait",
};

interface Props {
  user: any;
  identity: any;
  aliases: any;
  token: any;
}

const Issuers: React.FC<Props> = React.memo(
  ({ user, identity, aliases, token }) => {
    const [state, dispatch] = useTracked();
    const history = useHistory();
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [issuers, setIssuers] = useState<any[]>([]);
    const [selectedIssuer, setSelectedIssuer] = useState<any>(null);
    const [isOpenViewIssuer, setIsOpenViewIssuer] = useState<boolean>(false);
    const [isOpenToast, setIsOpenToast] = useState(false);
    const [cardView, setCardView] = useState<any>("list");
    const [toastData, setToastData] = useState({
      color: "",
      message: "",
    });
    const [isOpenCameraPermissionDialog, setIsOpenCameraPermissionDialog] =
      React.useState<boolean>(false);
    const [isCameraPermissionDisabled, setIsCameraPermissionDisabled] =
      React.useState<boolean>(false);

    const [lastActions, setLastActions] = useState<any[]>([]);

    useEffect(() => {
      if (user.isFirstTimeLogin && !user.accountLabel) {
        history.replace("/personalize");
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user]);

    useIonViewWillEnter(() => {
      if (identity) {
        fetchData(identity);
      }
    }, [identity]);

    React.useEffect(() => {
      if (state.authorizationActionTimestamp) {
        fetchData(identity);
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state.authorizationActionTimestamp]);

    const fetchData = async (identity: string) => {
      try {
        setIsLoading(true);

        const issuersResponse: any = await getIssuers(identity);
        if (issuersResponse?.status === 200) {
          const { data = [] } = issuersResponse;
          const activeIssuers = data.filter((val: any) => val.active);
          setIssuers(activeIssuers);
        }
        const filter = { status: "NOT_PENDING" };
        const limit = 5;
        const requestsHistory: any = await getRequestHistoryByIdentity(
          identity,
          filter,
          limit
        );
        if (requestsHistory?.status === 200) {
          const { data = [] } = requestsHistory;
          setLastActions(data);
        }

        setIsLoading(false);
      } catch (e) {
        console.log(e);
      }
    };

    const fetchIssuers = async () => {
      try {
        setIsLoading(true);

        const issuersResponse: any = await getIssuers(identity);
        if (issuersResponse?.status === 200) {
          const { data = [] } = issuersResponse;
          const activeIssuers = data.filter((val: any) => val.active);
          setIssuers(activeIssuers);
        }

        setIsLoading(false);
      } catch (e) {
        console.log(e);
        setIsLoading(false);
      }
    };

    const getIssuer = (appId: string) => {
      let appInfo: any = {};
      const { color, background } = smartColors();
      switch (appId) {
        case "2": {
          appInfo = {
            id: v4(),
            appId: appId,
            name: "Abaxx Messenger",
            type: "verifiedCredentials",
            color,
            background,
            url: "https://app.abaxx.id",
            identity: identity,
            active: true,
          };
          break;
        }
        case "3": {
          appInfo = {
            id: v4(),
            appId: appId,
            name: "Abaxx Trading",
            type: "verifiedCredentials",
            color,
            background,
            url: "https://trade.abaxx.exchange/",
            identity: identity,
            active: true,
          };
          break;
        }
        case "4": {
          appInfo = {
            id: v4(),
            appId: appId,
            name: "Abaxx Sign",
            type: "verifiedCredentials",
            color,
            background,
            url: "https://sign.abaxx.id/",
            identity: identity,
            active: true,
          };
          break;
        }
        case "5": {
          appInfo = {
            id: v4(),
            appId: appId,
            name: "Abaxx Clearing",
            type: "verifiedCredentials",
            color,
            background,
            url: "https://clearing.abaxx.exchange/",
            identity: identity,
            active: true,
          };
          break;
        }
      }
      return appInfo;
    };

    const getName = (appId: number) => {
      let name: any;
      switch (appId) {
        case 1: {
          name = "Verifier";
          break;
        }
        case 2: {
          name = "Abaxx Messenger";
          break;
        }
        case 3: {
          name = "Abaxx Exchange";
          break;
        }
        case 4: {
          name = "Sign abaxx";
          break;
        }
        case 5: {
          name = "Clearing";
          break;
        }
        default: {
          name = "Verifier";
          break;
        }
      }

      return name;
    };

    const getAppInfo = (scannedData: any) => {
      let appId = "";
      let channel = "";
      let pushToken = "";
      let authRequestId = "";

      const [channelSlug, appIdSlug, pushTokenSlug, authRequestIdSlug] =
        scannedData.split(",");

      if (appIdSlug) {
        appId = appIdSlug.substr(appIdSlug.indexOf("=") + 1, appIdSlug.length);
      }

      if (channelSlug) {
        channel = channelSlug.substr(
          channelSlug.indexOf("=") + 1,
          channelSlug.length
        );
      }

      if (pushTokenSlug) {
        pushToken = pushTokenSlug.substr(
          pushTokenSlug.indexOf("=") + 1,
          pushTokenSlug.length
        );
      }

      if (authRequestIdSlug) {
        authRequestId = authRequestIdSlug.substr(
          authRequestIdSlug.indexOf("=") + 1,
          authRequestIdSlug.length
        );
      }

      return {
        appId,
        channel,
        pushToken,
        authRequestId,
      };
    };

    // publish PN that qr code is scanned using unique id from data
    const informTarget = async (channel: string, authRequestId: string) => {
      let message: any = { authRequestId };
      let isValid: boolean = true;

      if (channel.startsWith("0x") && channel !== identity) {
        isValid = false;
        message.message = "Invalid account";
      }

      if (state.mqm) {
        await state.mqm.pubnub.publish({
          channel,
          message,
          meta: { type: "qrCodeScanned" },
        });
      }

      return isValid;
    };

    // const getIssuersPayload = (issuer: any, issuers: any[] = []) => {
    //   if (issuer) {
    //     const index = _findIndex(
    //       (val: any) => val.appId === issuer.appId,
    //       issuers
    //     );

    //     if (index !== -1) {
    //       issuers.splice(index, 1, issuer);
    //       issuers = [...issuers];
    //     } else {
    //       issuers = [...issuers, issuer];
    //     }
    //   }

    //   return JSON.stringify(issuers);
    // };

    const handleQrClick = async () => {
      try {
        setIsLoading(true);
        setIsCameraPermissionDisabled(false);
        // const scannedData = { text: "channel=64ab6a03-f3be-40db-acf4-0c39aaba9475,app_id=2" }; // test data
        // const scannedData = { text: 'channel=64ab6a03-f3be-40db-acf4-0c39aaba9475,app_id=3' }; // test data
        // const scannedData = { text: "channel=64ab6a03-f3be-40db-acf4-0c39aaba9475,app_id=4" }; // test data
        // const scannedData = { text: 'channel=64ab6a03-f3be-40db-acf4-0c39aaba9475,app_id=5' }; // test data

        await BarcodeScanner.scan(options)
          .then(async (scannedData: any) => {
            if (scannedData && scannedData.text) {
              const { appId, channel, pushToken, authRequestId } = getAppInfo(
                scannedData.text
              );

              // console.log('appId', appId)
              // console.log('channel', channel)
              // console.log('pushToken', pushToken)

              if (channel && appId && authRequestId) {
                const isValid = await informTarget(channel, authRequestId);
                if (isValid) {
                  // post auth-login
                  const resp = await authLogin(
                    aliases[0].alias.toString(),
                    appId, // app id from device
                    channel, // device id from device
                    pushToken, //push token from device
                    token,
                    authRequestId
                  );

                  if (resp && resp.status === 200 && resp.token) {
                    const existing: any = await getIssuers(
                      identity,
                      Number(appId)
                    );

                    if (
                      existing?.status === 200 &&
                      existing?.data?.length > 0
                    ) {
                      const { data = [] } = existing;
                      const deactiveIssuers = data.filter(
                        (val: any) => !val.active
                      );
                      if (deactiveIssuers.length) {
                        await updateIssuer(deactiveIssuers[0]?.id, {
                          ...deactiveIssuers[0],
                          ...{ active: true },
                        });
                        await createRequestHistory({
                          user,
                          appId: deactiveIssuers[0]?.appId,
                          alias: user.email,
                          type: "update_issuer",
                          status: "UPDATED",
                          name: getName(deactiveIssuers[0]?.appId),
                        });
                        fetchIssuers();
                        fetchData(identity);
                        ShowToastSuccessMessage(
                          "Issuer activate and device login verified."
                        );
                      } else {
                        ShowToastSuccessMessage("Device login verified.");
                      }
                    } else {
                      const issuer = getIssuer(appId);

                      if (issuer && issuer.id) {
                        const resp: any = await setIssuer(identity, issuer);

                        if (resp?.data?.id) {
                          setIssuers([...issuers, resp.data]);
                          fetchData(identity);
                          showToast(
                            "success",
                            "Issuer was successfully saved."
                          );
                        } else {
                          showToast(
                            "danger",
                            "Something went wrong while saving issuer."
                          );
                        }
                      } else {
                        showToast(
                          "danger",
                          "Something went wrong while processing login."
                        );
                      }
                    }
                    setIsLoading(false);
                  } else {
                    setIsLoading(false);
                  }
                } else {
                  showToast("danger", "Invalid account.");
                  setIsLoading(false);
                }
              } else {
                showToast("danger", "Invalid QR code");
              }
            } else {
              setIsLoading(false);
            }
          })
          .catch((e: any) => {
            setIsLoading(false);
            console.log(e);
          });
      } catch (e) {
        console.log(e);
        setIsLoading(false);

        if (typeof e === "string" && e === "cordova_not_available") {
          showToast("danger", "QR Scanner not supported.");
        } else if (e === "Illegal access") {
          setIsCameraPermissionDisabled(true);
          setIsOpenCameraPermissionDialog(true);
        } else {
          showToast(
            "danger",
            "You’ve disabled access to your camera. If you’d like to use qrcode scanner, you can change this permission in your device’s Settings."
          );
        }
      }
    };

    const showToast = (color: string, message: string) => {
      setToastData((prev: any) => ({
        ...prev,
        color,
        message,
      }));
      setIsOpenToast(true);
    };

    const handleUpdateIssuer = async (
      payload: any,
      autoClose?: boolean,
      isDeactivate?: boolean
    ) => {
      try {
        if (payload && payload.id) {
          setIsLoading(true);

          const resp: any = await updateIssuer(payload.id, payload);

          if (resp?.status === 200) {
            dispatch({ type: "setIssuer", issuer: payload });

            if (isDeactivate) {
              ShowToastSuccessMessage("Issuer was successfully deactivated.");
            } else {
              ShowToastSuccessMessage("Issuer was successfully updated.");
            }
          } else {
            showToast("danger", "Something went wrong while updating issuer.");
          }

          setIsLoading(false);
        } else {
          showToast("danger", "Something went wrong while updating issuer.");
        }

        if (autoClose) {
          setIsOpenViewIssuer(false);
        }
        fetchIssuers();
        fetchData(identity);
      } catch (e) {
        console.log(e);
        setIsLoading(true);

        if (autoClose) {
          setIsOpenViewIssuer(false);
        }
      }
    };

    const getTitle = (appId: number) => {
      let title: any;
      switch (appId) {
        case 1: {
          title = "Verifier";
          break;
        }
        case 2: {
          title = "Messenger";
          break;
        }
        case 3: {
          title = "Exchange";
          break;
        }
        case 4: {
          title = "Sign Abaxx";
          break;
        }
        case 5: {
          title = "Clearing";
          break;
        }
        default: {
          title = "Verifier";
          break;
        }
      }

      return title;
    };

    const getSubTitle = (type: string) => {
      let subTitle: any;
      switch (type) {
        case "create_issuer": {
          subTitle = "Issuer added";
          break;
        }
        case "update_issuer": {
          subTitle = "Issuer updated";
          break;
        }
        case "deactivate_issuer": {
          subTitle = "Issuer deactivated";
          break;
        }
        case "create_account": {
          subTitle = "Created account";
          break;
        }
        case "update_account": {
          subTitle = "Updated account";
          break;
        }
        case "delete_account": {
          subTitle = "Deleted account";
          break;
        }
        default: {
          subTitle = "Authorization";
          break;
        }
      }

      return subTitle;
    };

    const formatCreatedAccountEmail = (email: string) => {
      let formattedEmail: any = "";

      if (email) {
        const targetStr = email.substring(0, email.indexOf("@"));
        const mailDomain = email.substring(email.indexOf("@"), email.length);

        targetStr.split("").forEach((val: string, index: number) => {
          formattedEmail = `${formattedEmail}*`;
        });

        formattedEmail = `${formattedEmail}${mailDomain}`;
      }

      return formattedEmail;
    };

    const getDisplayActionLabel = (val: any) => {
      const title = getTitle(Number(val.appId));

      if (val.requestAction?.includes("api-key")) {
        return `Action - ${title}`;
      } else if (val.type === "sign_in") {
        return `Sign In - ${title}`;
      } else {
        switch (val.type) {
          case "create_issuer":
            return `Issuer ${val.name} was added`;

          case "update_issuer":
            return `Issuer ${val.name} was updated`;

          case "deactivate_issuer":
            return `Issuer ${val.name} was deactivated`;

          case "create_account":
            return `${formatCreatedAccountEmail(val.alias)} Account created`;

          case "update_account":
            return `${formatCreatedAccountEmail(val.alias)} Account updated`;

          case "delete_account":
            return `${formatCreatedAccountEmail(val.alias)} Account deleted`;

          default:
            return "";
        }
      }
    };

    return (
      <IonPage className="issuers-page">
        <PrivateHeader title="Issuers" />
        <IonContent>
          <div className="header-content">
            <div className="issuers-list-title">My Issuers</div>
            <div className="switch-btn">
              <IonSegment
                mode="ios"
                value={cardView}
                onIonChange={(e) => {
                  setCardView(e.detail.value);
                }}
              >
                <IonSegmentButton value="list">
                  <IonIcon icon={menuOutline} />
                </IonSegmentButton>
                <IonSegmentButton value="carousel">
                  <IonIcon icon={carouselHorizontal} />
                </IonSegmentButton>
              </IonSegment>
            </div>
          </div>
          <div
            className="issuers-container"
            style={{
              height:
                issuers.length > 0 && cardView === "list"
                  ? `${(issuers.length - 1) * 80 + 150}px`
                  : "auto",
            }}
          >
            {cardView === "list" ? (
              issuers.map((val: any, index: number) => {
                const { name, type, color, background } = val;
                const transform =
                  index > 0 ? `translateY(-${70 * index}px)` : ""; // 70px card gap

                return (
                  <IonCard
                    key={index}
                    className="issuer-item"
                    style={{ transform, background, color, margin: "0px 18px" }}
                    onClick={() => {
                      setSelectedIssuer(val);
                      setIsOpenViewIssuer(true);
                    }}
                  >
                    <IonCardContent>
                      <div className="content-container">
                        <div className="top-section">
                          <div className="issuer-avatar">
                            <IonAvatar>
                              <IonImg
                                src={cardAvatar}
                                alt="avatar"
                                style={{ width: "34px", height: "34px" }}
                              />
                            </IonAvatar>
                          </div>

                          <div className="issuer-type">
                            <IonText>{name}</IonText>
                          </div>
                        </div>

                        <div className="bottom-section">
                          {type === "identity" ? (
                            <React.Fragment>
                              <IonText>Identity</IonText>
                              <IonIcon icon={starOutline} />
                            </React.Fragment>
                          ) : (
                            <IonText>Verified Credentials</IonText>
                          )}
                        </div>
                      </div>
                    </IonCardContent>
                  </IonCard>
                );
              })
            ) : (
              <div>
                {/* 
                // @ts-ignore */}
                <Carousel
                  itemsToShow={1}
                  isRTL={false}
                  showArrows={false}
                  outerSpacing={25}
                  itemPadding={[0, 10]}
                  pagination={false}
                >
                  {issuers.map((val: any, index: number) => {
                    const { name, type, color, background } = val;

                    return (
                      <IonCard
                        key={index}
                        className="issuer-item"
                        style={{ background, color, width: "100%" }}
                        onClick={() => {
                          setSelectedIssuer(val);
                          setIsOpenViewIssuer(true);
                        }}
                      >
                        <IonCardContent>
                          <div className="content-container">
                            <div className="top-section">
                              <div className="issuer-avatar">
                                <IonAvatar>
                                  <img
                                    src={cardAvatar}
                                    alt="avatar"
                                    style={{ width: "34px", height: "34px" }}
                                  />
                                </IonAvatar>
                              </div>

                              <div className="issuer-type">
                                <IonText>{name}</IonText>
                              </div>
                            </div>

                            <div className="bottom-section">
                              {type === "identity" ? (
                                <React.Fragment>
                                  <IonText>Identity</IonText>
                                  <IonIcon icon={starOutline} />
                                </React.Fragment>
                              ) : (
                                <IonText>Verified Credentials</IonText>
                              )}
                            </div>
                          </div>
                        </IonCardContent>
                      </IonCard>
                    );
                  })}
                </Carousel>
              </div>
            )}
            {issuers.length === 0 && lastActions.length > 0 && !isLoading && (
              <div className="empty-issuers-content">
                <IonCard
                  className="issuer-item"
                  style={{ background: "#374151", color: "#fff" }}
                >
                  <IonCardContent>
                    <div className="content-container">
                      <div className="top-section">
                        <span className="issuer-avatar-circle"></span>

                        <div className="issuer-type">
                          <span className="empty-text"></span>
                        </div>
                      </div>

                      <div className="bottom-section">
                        <span className="empty-text"></span>
                      </div>
                    </div>
                  </IonCardContent>
                </IonCard>
                <div className="empty-title-card">
                  You don’t have any issuers yet
                </div>
                <div className="empty-subtitle-card">
                  Seems you don’t have any credentials here.
                  <br />
                  Please add your first issuer by clicking on the button below.
                </div>
              </div>
            )}
            {issuers.length === 0 && lastActions.length === 0 && (
              <div className="empty-issuers-content">
                <div className="empty-page-container">
                  <IonImg className="empty-image" src={illustrations} />
                  <div className="empty-title">Page is empty</div>
                  <div className="empty-subtitle">
                    Seems you don’t have any credentials here.
                    <br />
                    Please, add your first issuer by clicking on the button
                    below.
                  </div>
                </div>
              </div>
            )}
          </div>
          {lastActions.length > 0 && (
            <IonList className="history-list">
              <div className="list-header-title"> Last Actions </div>
              {lastActions.map((val: any, index: number) => {
                const subTitle = getSubTitle(val.type);

                return (
                  <IonItem key={index} lines="full">
                    <IonLabel className="title">
                      {getDisplayActionLabel(val)}
                      <div className="list-subtitle">
                        <h6>{subTitle}</h6>
                        <h6>{moment.unix(val.createdAt).format("MMM DD")}</h6>
                      </div>
                    </IonLabel>
                  </IonItem>
                );
              })}
            </IonList>
          )}
          <IonFab
            vertical="bottom"
            horizontal="center"
            slot="fixed"
            className="custom-fab-btn"
          >
            <IonFabButton mode="ios">
              <IonIcon icon={add} />
            </IonFabButton>
            <IonFabList side="start" className="scan-add-btn">
              <IonFabButton mode="ios" onClick={handleQrClick}>
                <IonIcon icon={qrCodeIcon} />
              </IonFabButton>
            </IonFabList>
            <IonFabList side="end" className="manual-add-btn">
              <IonFabButton mode="ios">
                <IonIcon icon={cameraOutline} />
              </IonFabButton>
            </IonFabList>
          </IonFab>

          {isLoading && <IonLoading isOpen={isLoading} />}

          <IonToast
            position="top"
            duration={2000}
            isOpen={isOpenToast}
            color={toastData.color}
            message={toastData.message}
            onDidDismiss={() => setIsOpenToast(false)}
          />
        </IonContent>

        <ViewIssuer
          data={selectedIssuer}
          user={user}
          isOpen={isOpenViewIssuer}
          setIsOpen={setIsOpenViewIssuer}
          updateIssuer={handleUpdateIssuer}
        />
        {isOpenCameraPermissionDialog && isCameraPermissionDisabled && (
          <CameraPermissionDialog
            isOpen={isOpenCameraPermissionDialog}
            setIsOpen={setIsOpenCameraPermissionDialog}
          />
        )}
      </IonPage>
    );
  }
);

const MemoizedIssuers = () => {
  const [state] = useTracked();
  const { user, identity, aliases, token } = state;
  return (
    <Issuers user={user} identity={identity} aliases={aliases} token={token} />
  );
};

export default MemoizedIssuers;
